<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="技术人员基本信息变更" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="danger" v-if="editData.djzt === '提交'" v-show="submitShow" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="变更表编号">
                                        <a-input ref="bgsqbbh" v-model="editData.bgsqbbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="变更日期">
                                        <a-date-picker ref="bgrq" v-model="editData.bgrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="姓名">
                                        <a-input ref="xm" v-model="editData.xm" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <div class="image-container">
                                        <UploadImage :attachCfg="attachCfg_Edit" :state="2" />
                                    </div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="性别">
                                        <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="民族">
                                        <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="editData.mz" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="出生日期">
                                        <a-date-picker ref="csrq" v-model="editData.csrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="证件类型">
                                        <FGDictSelectCN ref="zjlx" dictNo="RY100104" v-model="editData.zjlx" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="证件号码">
                                        <a-input ref="zjhm" v-model="editData.zjhm" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所属单位编号">
                                        <a-input ref="ssdwbh" v-model="editData.ssdwbh" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="所属单位名称">
                                        <a-input ref="ssdwmc" v-model="editData.ssdwmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="区域编号">
                                        <a-input ref="qybh" v-model="editData.qybh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="区域名称">
                                        <a-input ref="qymc" v-model="editData.qymc" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="人员类别">
                                        <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="editData.rylb" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职务">
                                        <a-input ref="zw" v-model="editData.zw" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="职称">
                                        <FGDictSelectCN ref="zc" dictNo="RY100109" v-model="editData.zc" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row :gutter="[0, 6]">
                                <a-col :span="6">
                                    <a-form-item label="职称专业">
                                        <a-input ref="zczy" v-model="editData.zczy" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="批准时间">
                                        <a-date-picker ref="pzsj" v-model="editData.pzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="毕业院校">
                                        <a-input ref="byyx" v-model="editData.byyx" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="毕业时间">
                                        <a-date-picker ref="bysj" v-model="editData.bysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="所学专业">
                                        <a-input ref="sxzy" v-model="editData.sxzy" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="学历">
                                        <FGDictSelectCN ref="xl" dictNo="RY100106" v-model="editData.xl" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="学位">
                                        <FGDictSelectCN ref="xw" dictNo="RY100107" v-model="editData.xw" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="参加工作时间">
                                        <a-date-picker ref="cjgzsj" v-model="editData.cjgzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="从业时间">
                                        <a-date-picker ref="cysj" v-model="editData.cysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="固定电话">
                                        <a-input ref="gddh" v-model="editData.gddh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="移动电话">
                                        <a-input ref="yddh" v-model="editData.yddh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="个人简历">
                                        <a-input ref="grjl" v-model="editData.grjl" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="上岗证编号">
                                        <a-input ref="sgzbh" v-model="editData.sgzbh" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="变更说明">
                                        <a-input ref="bgsm" v-model="editData.bgsm" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="首次登记时间">
                                        <a-date-picker ref="sczcsj" v-model="editData.sczcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入部门">
                                        <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入人">
                                        <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="录入时间">
                                        <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6">
                                    <a-form-item label="备注">
                                        <a-input ref="bz" v-model="editData.bz" disabled />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form>
                        <!-- 操作日志 -->
                        <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "JsrybgForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            tableData: [],
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    activated() {
        this.submitShow = true;
        // 修改，加载数据
        this.loadData();
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.bgsqbbh.focus();
        });
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg_Edit() {
            return {
                fktable: "RY_BGSQB",
                fkvalue: this.editData.id
            };
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "RY_BGSQB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "RY3000"
            };
        }
    },
    methods: {
        getState(djzt) {
            if (djzt === "提交" || djzt === "生效" || djzt === "复核通过" || djzt === "复核否决") {
                return true;
            } else {
                return false;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrybg/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        },
        unSubmit() {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/jsrybg/unSubmit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bgsqbbh.focus();
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
